import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\" stroke-width=\"1.5\" transform=\"translate(6 6)\"><rect width=\"32\" height=\"32\" rx=\"4\"></rect><g stroke-linecap=\"round\"><path d=\"M6.25 12.5v15M12.75 16.5v11M19.25 18.5v9M25.75 15.5v12M3 22l9.5 2.5 7-2.5 9.5 2\"></path></g><g transform=\"translate(4 5)\"><path stroke-linecap=\"round\" d=\"M0 3h12M18 3h5\"></path><circle cx=\"15\" cy=\"3\" r=\"3\"></circle></g></g>", 1)
  ])))
}
export default { render: render }